module.exports = __webpack_public_path__ + "media/images/icons/maximize-e53d228090275f5a9db82270cac159ca.svg";